"use strict";

exports.__esModule = true;
exports.config = void 0;
var config = exports.config = {
  id: "alerts",
  name: "Alerts",
  element: {
    props: {
      width: 1280,
      height: 768,
      rowCount: 12,
      columnCount: 12,
      timeRangeKind: "multiDay"
    },
    children: [{
      props: {
        dataSource: "Alerts",
        gridRowStart: 1,
        gridRowEnd: 13,
        gridColumnStart: 1,
        gridColumnEnd: 13,
        configuration: {
          enablePagination: true,
          overFetchAll: false,
          defaultPageSize: 100,
          enableFetchOnSort: true,
          sort: [{
            property: "created",
            direction: "desc"
          }]
        },
        x: 0,
        y: 0,
        height: 64,
        width: 256
      },
      children: [{
        props: {
          id: "acknowledged",
          name: "Ack",
          type: "boolean",
          enableSorting: false,
          canSearch: false,
          x: 0,
          y: 0,
          height: 64,
          width: 256,
          defaultWidth: 64
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "description",
          name: "Description",
          type: "string",
          enableSorting: true,
          canSearch: true,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "created",
          name: "Created At",
          type: "date",
          dateFormat: "ShortDateTime",
          usePlantTime: true,
          defaultSortOrder: "DESC",
          enableSorting: true,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "deviceName",
          sortId: "device.value",
          name: "Device",
          type: "deviceName",
          enableSorting: true,
          canFilter: true,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "tags",
          name: "Tags",
          type: "string",
          canFilter: true,
          enableSorting: false,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }],
      type: "DataTable"
    }],
    type: "Report"
  }
};